import { languageHelper } from "../../../config/helperFunctions";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";

function BulkUploadDeliveryPrices() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [result, setResult] = useState(null);

  const navigate = useNavigate();

  const handleDownloadTemplate = () => {
    setDownloading(true);
    axios
      .get(`${apiKey}/api/rms/admin/delivery-company-prices/template`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
        params: {
          outletId: user?.user.outlet_id,
        },
        responseType: "blob",
      })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "delivery-company-prices-template.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        toast.error(languageHelper("Failed to download template"), {
          position: "bottom-right",
          autoClose: 5000,
          theme: "colored",
        });
      })
      .finally(() => setDownloading(false));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!file) {
      toast.error(languageHelper("Please choose a file first"), {
        position: "bottom-right",
        autoClose: 5000,
        theme: "colored",
      });
      return;
    }

    setLoading(true);
    setResult(null);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("outlet_id", user?.user.outlet_id);

    axios
      .post(`${apiKey}/api/rms/admin/delivery-company-prices/bulk-upload`, formData, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setResult(res.data);
        toast.success(
          `${languageHelper("Prices set")}: ${res.data.prices_set}`,
          {
            position: "bottom-right",
            autoClose: 5000,
            theme: "colored",
          }
        );
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || languageHelper("Something went wrong"),
          {
            position: "bottom-right",
            autoClose: 5000,
            theme: "colored",
          }
        );
      })
      .finally(() => setLoading(false));
  };

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-d-bg-text text-2xl">
            {languageHelper("Bulk Upload Delivery Prices")}
          </h1>
        </div>

        <p className="text-d-bg-text text-sm mb-4">
          {languageHelper(
            "Download the template, fill in a price per item per delivery company, then upload it back. Items are matched by English or Arabic name -- items not found in the system are skipped and listed below, they are not added automatically."
          )}
        </p>

        <div className="w-full">
          <form className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full">
              <label htmlFor="" className="w-full">
                <span className="bg-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2">
                  {languageHelper("Upload File")}
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    onChange={(e) => setFile(e.target.files[0])}
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                  />
                </div>
              </label>
            </div>

            <span className="w-full bg-d-cat-btn h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
                disabled={loading}
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="/assets/gif/button_loader.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Submit")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                {languageHelper("Back")}
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="button"
                onClick={handleDownloadTemplate}
                disabled={downloading}
              >
                {downloading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="/assets/gif/button_loader.gif"
                      alt=""
                    />
                  </span>
                )}
                {languageHelper("Download Template")}
              </button>
            </div>
          </form>

          {result && (
            <div className="mt-6 border-t pt-4">
              <h2 className="text-d-bg-text text-lg font-semibold mb-2">
                {languageHelper("Import Result")}
              </h2>
              <ul className="text-sm text-d-bg-text list-disc pl-5">
                <li>
                  {languageHelper("Items matched")}: {result.matched_items}
                </li>
                <li>
                  {languageHelper("Prices set")}: {result.prices_set}
                </li>
              </ul>

              {result.not_found_items?.length > 0 && (
                <div className="mt-3">
                  <p className="text-red-600 text-sm font-semibold">
                    {languageHelper(
                      "The following items were not found in the system and were skipped"
                    )}
                    :
                  </p>
                  <ul className="text-sm text-red-600 list-disc pl-5">
                    {result.not_found_items.map((name, idx) => (
                      <li key={idx}>{name}</li>
                    ))}
                  </ul>
                </div>
              )}

              {result.unknown_company_columns?.length > 0 && (
                <div className="mt-3">
                  <p className="text-yellow-700 text-sm font-semibold">
                    {languageHelper(
                      "The following spreadsheet columns did not match any delivery company and were ignored"
                    )}
                    :
                  </p>
                  <ul className="text-sm text-yellow-700 list-disc pl-5">
                    {result.unknown_company_columns.map((name, idx) => (
                      <li key={idx}>{name}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </main>
  );
}

export default BulkUploadDeliveryPrices;
